export const BASE_URL = "https://patumba-kyc-api.hobbiton.tech";
